// Loads shared/storage-health.js, its own lazy chunk, the first time something needs it.
let url = "";
try { url = __RVM.healthJs; } catch { /* unit tests have no build defines */ }
let mod = null;
export function loadHealth() {
	if (!mod) mod = (url ? import(url) : Promise.reject(new Error("no health chunk"))).catch((e) => { mod = null; throw e; });
	return mod;
}

// A save file or a cloud backup was just made ("file" | "cloud"), or a backup was restored
// ("restore"): note it and ask the browser to keep Re:Vault's saves.
// Never holds things up for long: a reload may be waiting on it.
export function noteSafe(kind) {
	const run = loadHealth().then((m) => {
		if (kind !== "restore") m.markSafe(kind);
		return m.maybePersist(kind === "restore" ? "restore" : "backup");
	}).catch(() => null);
	return Promise.race([run, new Promise((r) => setTimeout(() => r(null), 1500))]);
}
